module.exports = __webpack_public_path__ + "img/empty-video.ef16a984.svg";